import { render, staticRenderFns } from "./moneyMovementsTable.vue?vue&type=template&id=fb67d122&"
import script from "./moneyMovementsTable.vue?vue&type=script&lang=ts&"
export * from "./moneyMovementsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports